const DATA_KEY = {
    PROVIDER: 'provider'
}

const PROVIDER = {
    VIDEOMONSTER: null,
    VCHANGE: 'vchange',
    CAFE24: 'cafe24',
    WADIZ: 'wadiz',
    VIDEO09: 'video09'
}

const ClearProvider = () => sessionStorage.removeItem(DATA_KEY.PROVIDER)

const SetProvider = (provider) => {
    let Provider = provider;
    if (typeof Provider === "string") Provider = Provider.trim();
    sessionStorage.setItem(DATA_KEY.PROVIDER, Provider)
}

const GetProvider = () => {
    const provider = sessionStorage.getItem(DATA_KEY.PROVIDER);
    if (provider === "null") return null;

    return provider;
}
/**
 * 현재 Provider와 비교
 * @param {string} provider DataManager.PROVIDER 
 * @returns boolean
 */
const IsProvider = (provider) => GetProvider() === provider
/**
 * Provider 중 하나라도 포함되어 있다면 true 반환
 * @param  {...any} providers 
 * @returns boolean
 */
const IncludesProvider = (...providers) => {
    const curProvider = GetProvider()
    for (let i = 0; i < providers.length; ++i) 
        if (curProvider === providers[i]) return true
    return false;
}
export default {
    PROVIDER,

    ClearProvider,
    SetProvider,
    GetProvider,
    IsProvider,
    IncludesProvider,
}